import { observable, reaction, action } from 'mobx';

export const playBarStore = observable({
	isReady: false,
	isPlaying: false,
	currentTime: '00:00 / 00:00'
});

export const setIsPlaying = action((value) => {
	playBarStore.isPlaying = value;
});

reaction(
	() => playBarStore.isPlaying,
	(isPlaying) => {
		// Aquí puedes colocar la lógica que necesites cuando 'isPlaying' cambie
		console.log('El estado de reproducción ha cambiado:', isPlaying);
	}
);